import type { InvoiceResponse, InvoiceStatus } from '../../api/models/bff/Invoice';
import { generateId } from '../utils/generators';

export function createMockInvoice(overrides?: Partial<InvoiceResponse>): InvoiceResponse {
  return {
    id: generateId('inv'),
    number: `INV-${new Date().getFullYear()}-001`,
    status: 'PAID' as InvoiceStatus,
    amount: '156.00',
    balance: '156.00',
    currency: 'USD',
    createdAt: new Date().toISOString(),
    targetDate: new Date().toISOString(),
    ...overrides,
  };
}

const MONTHS_AGO_OLDEST_INVOICE = 2;

/**
 * Create a list of unpaid invoices simulating an OVERDUE/SUSPENDED scenario.
 * Returns one UNPAID and one FAILED invoice so both Tag statuses are visible.
 */
export function createMockOverdueInvoices(): InvoiceResponse[] {
  const now = new Date();
  const oneMonthAgo = new Date(now);
  oneMonthAgo.setMonth(now.getMonth() - 1);
  const twoMonthsAgo = new Date(now);
  twoMonthsAgo.setMonth(now.getMonth() - MONTHS_AGO_OLDEST_INVOICE);

  return [
    createMockInvoice({
      id: generateId('inv'),
      number: `INV-${now.getFullYear()}-001`,
      status: 'UNPAID',
      amount: '156.00',
      balance: '156.00',
      currency: 'USD',
      createdAt: twoMonthsAgo.toISOString(),
      targetDate: twoMonthsAgo.toISOString(),
    }),
    createMockInvoice({
      id: generateId('inv'),
      number: `INV-${now.getFullYear()}-002`,
      status: 'PARTIALLY_PAID',
      amount: '156.00',
      balance: '156.00',
      currency: 'USD',
      createdAt: oneMonthAgo.toISOString(),
      targetDate: oneMonthAgo.toISOString(),
    }),
  ];
}
